<template>
  <v-data-table
    :headers="headers"
    :items="userData"
    sort-by="calories"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Técnicos</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
              Actualizar Precios
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">Precios</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <!-- <v-col cols="12" sm="6" md="4">
                    <v-select
                      :items="editedItem.nombre"
                      v-model="editedItem.nombre"
                      label="Nombre"
                      dense
                      :keydown="addNombre(editedItem.nombre)"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.empresa"
                      label="Empresa"
                      :keydown="addEmpresa(editedItem.empresa)"
                    ></v-text-field>
                  </v-col> -->
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.instalaciones"
                      label="Instalaciones"
                      type="number"
                     
                    ></v-text-field>
                    <p  style="color:blue; font-size:14px">${{precios[0].instalaciones}}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.cambio_tecnologia"
                      label="Cambio de tecnologia"
                      type="number"
                      
                    ></v-text-field>
                    <p  style="color:blue; font-size:14px">${{precios[0].cambio_tecnologia}}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.servicio_tecnico"
                      label="Servicio técnico"
                      type="number"                     
                    ></v-text-field>
                    <p  style="color:blue; font-size:14px">${{precios[0].servicio_tecnico}}</p>
                  </v-col>
                  <!-- <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.total_mes"
                      label="Total del mes"
                       :keydown="addTotal(editedItem.total_mes)"
                    ></v-text-field>
                  </v-col> -->
                
                
                  
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">
                Cancelar
              </v-btn>
              <v-btn color="blue darken-1" text @click="save"> Guardar </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5"
              >¿Está seguro de borrar este item?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete"
                >Cancelar</v-btn
              >
              <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                >OK</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
      </v-toolbar>
    </template>
    <template v-slot:[`item.importetotal`]="{ item }">
      <td>{{ item.instalaciones * precios[0].instalaciones + item.cambio_tecnologia * precios[0].cambio_tecnologia + item.servicio_tecnico * precios[0].servicio_tecnico}}</td>
</template>
    <template v-slot:[`item.estado`]="{ item }">
      <v-chip class="ma-2" color="secondary">{{item.estado}}</v-chip>
    </template>
    <!-- <template v-slot:[`item.actions`]="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
      <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
    </template> -->
    <template v-slot:no-data>
      <v-btn color="primary" > Reset </v-btn>
    </template>
  </v-data-table>
</template>

<script>
// import EquipoStore from "../store/index";
import { mapState } from "vuex";
import { getAllTecnicos , updatePrecios , getPrecios}from '../database.js'
export default {
  name: "Tecnicos",

  components: {},
  data: () => ({
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        text: "Nombre",
        align: "start",
        sortable: false,
        value: "nombre",
      },
      { text: "Empresa", value: "empresa" },
      { text: "Instalaciones", value: "instalaciones" },
      { text: "Cambio de Tecnología", value: "cambio_tecnologia" },
      { text: "Servicio Técnico", value: "servicio_tecnico" },
      { text: "Libres", value: "libres" },
      { text: "En Uso", value: "en_uso" },
      { text: "Total del mes", value: "importetotal" },      
      // { text: "Acciones", value: "actions", sortable: false },
    ],
    date: new Date(
      Date.now() - new Date().getTimezoneOffset() * 60000
    ).toLocaleDateString(),
    idprecios:"3rInyBxJ8fzv2jKaV4PG",
    // equipos: EquipoStore.data.tecnicosList,
    // asignados: ["Barney Gomez", "Jefe Gorgory", "Smithers"],
    // selectedAsignado: null,
    // editedIndex: -1,
    editedItem: {
      // nombre: "",
      // empresa: "",
      instalaciones:"",
      cambio_tecnologia: "",
      servicio_tecnico: "",
      fecha_actualizacion: ""
      // total_mes: "",       
    },
    defaultItem: {
      nombre: "",
      empresa: "",
      instalaciones:"",
      cambio_tecnologia: "",
      servicio_tecnico: "",
      total_mes: "", 
    },
  }),

  computed: {
    // formTitle() {
    //   return this.editedIndex === -1 ? "Nuevo Registro" : "Editar Registro";
    // },
    ...mapState({
      tecnicoList: (state) => state.tecnicoList,
      precios: (state) => state.preciosget,
      // users: (state) => state.users,
      users: (state) => {
  return state.users.filter(user => user.rol !== "Administrador");
}
      
    }),
    userData() {
      return this.users.map(item => ({
        ...item,
        cambio_tecnologia: item.cambio_tecnologia? item.cambio_tecnologia.length: 0,
        servicio_tecnico: item.servicio_tecnico? item.servicio_tecnico.length: 0,
        instalaciones: item.instalaciones? item.instalaciones.length: 0,
        libres: item.instalaciones? item.libres.length: 0,
        en_uso: item.instalaciones? item.en_uso.length: 0,
        // importetotal: item.instalaciones * this.precios[0].instalaciones 
      }));
    },
    totalMes() {
    return (this.editedItem.cambio_tecnologia * this.precios[0].cambio_tecnologia) + 
           (this.editedItem.instalaciones * this.precios[0].instalaciones) +
           (this.editedItem.servicio_tecnico * this.precios[0].servicio_tecnico);
  }
  
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  async created() {
     await getAllTecnicos()
     await getPrecios()
     console.log("users", this.users)
     console.log(this.cambio_tecnologia)
  },

  methods: {
  
    // async editItem(item) {
    //   this.editedIndex = this.equipos.indexOf(item);
    //   this.editedItem = Object.assign({}, item);
    //   // EquipoStore.data.usuarios = this.editedItem
    //   this.dialog = true;
    
    // },

    // deleteItem(item) {
    //   this.editedIndex = this.equipos.indexOf(item);
    //   this.editedItem = Object.assign({}, item);
    //   this.dialogDelete = true;
    // },

    // deleteItemConfirm() {
    //   this.equipos.splice(this.editedIndex, 1);
    //   this.closeDelete();
    // },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    // closeDelete() {
    //   this.dialogDelete = false;
    //   this.$nextTick(() => {
    //     this.editedItem = Object.assign({}, this.defaultItem);
    //     this.editedIndex = -1;
    //   });
    // },

    async save() {
      if (this.editedIndex > -1) {
        Object.assign(this.equipos[this.editedIndex], this.editedItem);

        await getAllTecnicos()
      } else {
        // this.equipos.push(this.editedItem);
        console.log("item:", this.editedItem)
        // EquipoStore.methods.addnewdataTecnicos(this.editedItem)
        this.editedItem.fecha_actualizacion = this.date
        this.$store.dispatch('setPrecios',this.editedItem);
        this.dialog = true;
        await updatePrecios(this.idprecios)
        // await addTecnico()
        await getPrecios()
        await getAllTecnicos()
      }
      this.close();
    },
    // addNombre(data){
    //   console.log(data);
    //   let propiedad = "nombre";
    //   EquipoStore.methods.addnewdataTecnicos(propiedad, data);
    //   console.log("store: ",EquipoStore.data.tecnicos[0].nombre);
    // },
    // addEmpresa(data){
    //   console.log(data);
    //   let propiedad = "empresa";
    //   EquipoStore.methods.addnewdataTecnicos(propiedad, data);
    //   console.log("store: ",EquipoStore.data.tecnicos[0].empresa);
    // },
    // addInstalaciones(data){
    //   console.log(data);
    //   let propiedad = "instalaciones";
    //   EquipoStore.methods.addnewdataTecnicos(propiedad, data);
    //   console.log("store: ",EquipoStore.data.tecnicos[0].instalaciones);
    // },
    // addCambio(data){
    //   console.log(data);
    //   let propiedad = "cambio_tecnologia";
    //   EquipoStore.methods.addnewdataTecnicos(propiedad, data);
    //   console.log("store: ",EquipoStore.data.tecnicos[0].cambio_tecnologia);
    // },
    // addServicio(data){
    //   console.log(data);
    //   let propiedad = "servicio_tecnico";
    //   EquipoStore.methods.addnewdataTecnicos(propiedad, data);
    //   console.log("store: ",EquipoStore.data.tecnicos[0].servicio_tecnico);
    // },
    // addTotal(data){
    //   console.log(data);
    //   let propiedad = "total_mes";
    //   EquipoStore.methods.addnewdataTecnicos(propiedad, data);
    //   console.log("store: ",EquipoStore.data.tecnicos[0].total_mes);
    // },
    
  },
};
</script>